import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { testId } from 'ui-components/services/testid-service';

import messages from './messages';

import style from './style.module.less';

const ThirdPartyBillingTooltip = ({ iconClassName, iconContainerClassName }) => {
  return (
    <Tooltip>
      <div className={iconContainerClassName} {...testId('rate-tooltip')}>
        <FontAwesomeIcon className={classnames(style.icon, iconClassName)} icon={faQuestionCircle} />
      </div>
      <TooltipContent>
        <div>
          <FormattedMessage {...messages.thirdPartyBillingTooltip} />
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default ThirdPartyBillingTooltip;

ThirdPartyBillingTooltip.propTypes = {
  iconClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string,
};
